import { ServiceAddressRequest } from '../../model/availability/service-address-request';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../service/notification.service';
import { ServiceAddress } from '../../model/availability/service-address';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AvailabilityService } from '../../service/availability.service';
import { Component, Inject, OnInit } from '@angular/core';
import { AddServiceAddressData } from './add-service-address-data';
import { DestroyComponent } from '../../common/destroy-component/destroy-component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-service-address',
  templateUrl: './add-service-address.component.html',
  styleUrls: ['./add-service-address.component.css']
})
export class AddServiceAddressComponent extends DestroyComponent implements OnInit {
  serviceAddress: ServiceAddress = new ServiceAddress();
  address: string;
  statesList: ServiceAddress[];
  serviceAddressForm: FormGroup;
  serviceAddressRequest: ServiceAddressRequest = new ServiceAddressRequest();

  constructor(
    public _availabilityService: AvailabilityService,
    private _notificationService: NotificationService,
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddServiceAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddServiceAddressData
  ) {
    super();
  }

  selectedState = "";
  selectState(event: Event) {
    this.selectedState = (event.target as HTMLSelectElement).value;
  }

  ngOnInit() {
    this.serviceAddressForm = this._formBuilder.group({
      address : new FormControl('', [Validators.required]),
      city: ['', Validators.required],
      isActive:[''],
      createdBy:[''],
      state: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern(/^[0-9]{1}[0-9]{4}$/),Validators.minLength(5), Validators.maxLength(5)]],
    });
    this.loadStates();
  }

  private _handleError(error: any) {
    console.log(error);
    this._notificationService.error('Service address addition failed');
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.serviceAddressForm.controls[controlName].hasError(errorName);
  }

  loadStates() {
    this._availabilityService.getStatesList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(" State " + data.states);
        this.statesList = data.states;
      }, error => console.log(error));
  }

  onSubmit() {
    if(this.serviceAddressForm.invalid){
      return;
    }
    this.serviceAddressRequest.serviceAddress = this.serviceAddressForm.value;
    this.serviceAddressRequest.serviceAddress.nursePractitionerId = this.data.providerId;  // Use the providerId passed via dialog data
    this._availabilityService.saveServiceAddressData(this.serviceAddressRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (!data.successFlag) {
          this._handleError(data);
          return;
        }
        this.dialogRef.close(this.serviceAddressForm.value);
        this._notificationService.success('Service address added successfully');
      }, error => this._handleError(error));
  }

  onNoClick(): void {
    this.dialogRef.close(false);
    console.log(this.serviceAddressForm.value);
  }
}
